import { Component } from '@verndale/core';
import { showOpacity } from '../helpers/motion';

class RecognitionRow extends Component {
  setupDefaults() {
    this.dom = {
      expandButton: this.el.querySelector('.btn--expand'),
      cards: this.el.querySelectorAll('.generic-card')
    };

    this.showExpandButton();
  }

  showExpandButton() {
    if (this.dom.cards.length < 4) {
      this.dom.expandButton.style.display = 'none';
    }
  }

  addListeners() {
    this.dom.expandButton?.addEventListener('click', this.expand.bind(this));
  }

  expand() {
    this.dom.cards.forEach(card => {
      card.style.display = 'block';
      showOpacity(card);
    });

    this.dom.expandButton.style.display = 'none';
  }
}

export default RecognitionRow;
